<template>
  <div class="select-card-container">
    <div v-for="item in list" :key="item.value" class="card-item" @click="$emit('input', item.value)">
      {{ item.label }}
      <img
        v-show="item.value === value"
        class="selected-icon"
        src="@/assets/icon-room-selected.png"
        alt
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'VSelectCard',
  ignore: true,
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    list: {
      type: Array,
      required: true,
      validate: val => val.every(i => i.label && i.value)
    }
  }
}
</script>

<style scoped lang="scss">
  .select-card-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: -12px;

    .card-item {
      color: #23253A;
      text-align: center;
      margin: 12px 12px 0 0;
      padding: 0 12px;
      min-width: 54px;
      height: 36px;
      line-height: 34px;
      background-color: #ffffff;
      border: 1px solid rgba(0,104,182,0.2);
      border-radius: 2px;
      box-shadow: 0 6px 10px 0 rgba(4,88,151,0.06);
      position: relative;
      cursor: pointer;

      .selected-icon {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 16px;
        height: 16px;
      }
    }
  }
</style>
